import {customerIoAuthService} from '_services';

import {oauthConstants, alertMessages, toastMessage} from '_constants';
import {SnackBar} from "../components/common";
import {history} from "../_helpers";
import {Toast} from "../components/v3/common/Toast";

function saveAccount(params) {
    function request() {
        return {type: oauthConstants.CUSTOMER_IO_SAVE_ACCOUNT_REQUEST};
    }

    function success(payload) {
        return {type: oauthConstants.CUSTOMER_IO_SAVE_ACCOUNT_SUCCESS, payload }
    }

    function failure() {
        return {type: oauthConstants.CUSTOMER_IO_SAVE_ACCOUNT_FAILURE}
    }

    return (dispatch) => {
        dispatch(request());

        customerIoAuthService.saveAccount(params)
            .then(
                (res) => {
                    dispatch(success(res));
                    history.push('/company/channels')
                    const {successMessage, options} = toastMessage.connectChannel;
                    Toast.showMessage(successMessage, options);
                },
                (error) => {
                    dispatch(failure(error));
                    SnackBar.showMessage(alertMessages.CUSTOMER_IO_AUTH_FAILURE);
                },
            );
    };
}

export const customerIoAuthActions = {
    saveAccount
};